"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const ClientDto_1 = require("./ClientDto");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
class ClientEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, client) {
        super();
        this._requiredFieldsSetStatus = {
            name: false,
            clientNumber: false,
            apiKey: false
        };
        this._dependencies = dependencies;
        if (client === undefined) {
            this._dto = new ClientDto_1.ClientDto();
        }
        else if (client instanceof ClientDto_1.ClientDto) {
            this._dto = new ClientDto_1.ClientDto(client);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (client instanceof ClientEntity) {
            this._dto = new ClientDto_1.ClientDto(client._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new ClientDto_1.ClientDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getName() {
        return this._dto.name;
    }
    setName(untrustedValue) {
        const maxLength = 60;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("name");
        this._requiredFieldsSetStatus.name = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("name", "Name is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("name", `Name has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.name) {
            return;
        }
        this._dto.name = _untrustedValue;
        this._setIsDirty(true);
    }
    getClientNumber() {
        return this._dto.clientNumber;
    }
    setClientNumber(untrustedValue) {
        const maxLength = 60;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("clientNumber");
        this._requiredFieldsSetStatus.clientNumber = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("clientNumber", "Client Number is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("clientNumber", `Client Number has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.clientNumber) {
            return;
        }
        this._dto.clientNumber = _untrustedValue;
        this._setIsDirty(true);
    }
    getApiKey() {
        return this._dto.apiKey;
    }
    setApiKey(untrustedValue) {
        const minLength = 20;
        const maxLength = 20;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("apiKey");
        this._requiredFieldsSetStatus.apiKey = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("apiKey", "API Key is required."));
        }
        else if (_untrustedValue.length < minLength) {
            this.addError(new ValidationError_1.ValidationError("apiKey", `API Key is below the minimum length (${minLength} chr).`));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("apiKey", `API Key has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.apiKey) {
            return;
        }
        this._dto.apiKey = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    getLastPushMessage() {
        return this._dto.lastPushMessage;
    }
    setLastPushMessage(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("lastPushMessage");
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("lastPushMessage", "Last Push Message is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("lastPushMessage", `Last Push Message has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.lastPushMessage) {
            return;
        }
        this._dto.lastPushMessage = _untrustedValue;
        this._setIsDirty(true);
    }
    loadAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.clientDatastore
                    .getAsync(id);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Client is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.clientDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.clientDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Client cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.clientDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.ClientEntity = ClientEntity;
//# sourceMappingURL=ClientEntity.js.map